import { useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigateQuery } from '@/hooks';
import type { UserState } from '@/redux/user/types';
import { getUserState } from '@/redux/user/selectors';

type HomeProps = {
  user: UserState;
};

const Home = ({ user }: HomeProps) => {
  const navigate = useNavigateQuery();

  useEffect(() => {
    if (!user.id) return;
    user.family ? navigate('/overview') : navigate('/editor');
  }, [user]);

  return null;
};

const mapStateToProps = (state: never) => ({
  user: getUserState(state)
});

export default connect(mapStateToProps)(Home);
